import {countriesExportingOrImporting} from './common/countries-exporting-or-importing';

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Please specify from which Countries
 * 
 * == final
 * question2
 * 
 * @param props 
 * @returns 
 */
export const countriesExportingChartCalculation = (props: any) => {
    return countriesExportingOrImporting(props, 'question2', 'Countries Exporting');
}